import Notification from '../../components/Notification/Notification';
import responseCodes from '../../constants/responseCodes';
import i18n from '../../i18n';
import * as candidateService from '../../services/candidateService';
import globalActionConstants from '../constants/globalActionConstants';
import strengthenQuestionConstants from '../constants/strengthenQuestionConstants';

const t = (key) => i18n.t(key, { ns: 'common' });

export const updateCandidateQuestions =
  (uuid, params, successCallback = () => {}) =>
  async (dispatch) => {
    dispatch({ type: globalActionConstants.SET_LOADING_ON });
    try {
      const response = await candidateService.updateCandidate(uuid, params);
      if (response.data.response_code === responseCodes.OK) {
        dispatch({
          type: strengthenQuestionConstants.GET_STRENGTHEN_QUESTION,
          payload: response.data.payload,
        });
        successCallback();
        Notification.success(t('notifications.strengthenQuestionsUpdated'));
      } else {
        Notification.error(response.error.message || response.data.error.message);
      }
    } catch (err) {
      Notification.error(t('notifications.somethingWentWrong'));
    } finally {
      dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    }
  };
